'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');

const NonAuthenticatedFeatures=[
'fdc.features.login'];let


StateChangeDirective=function(){function StateChangeDirective(){_classCallCheck(this,StateChangeDirective)}StateChangeDirective.prototype.




factory=function factory($rootScope,$state,$modalStack,userService,errorHandlers){
let stateAuthenticator=new StateAuthenticator(NonAuthenticatedFeatures,$state,$modalStack,userService,errorHandlers);
return{
restrict:'A',
link:function(scope){
$rootScope.$on('$stateChangeStart',function(){
stateAuthenticator.process.apply(stateAuthenticator,_toConsumableArray(_.toArray(arguments)));
});
}};

};_createClass(StateChangeDirective,null,[{key:'type',get:function(){return'directive'}},{key:'StateAuthenticator',get:function()

{
return StateAuthenticator;
}}]);return StateChangeDirective}();


StateChangeDirective.prototype.factory.$inject=['$rootScope','$state','$modalStack','userService','errorHandlers'];let

StateAuthenticator=function(){
function StateAuthenticator(nonAuthenticatedFeatures,$state,$modalStack,userService,errorHandlers){_classCallCheck(this,StateAuthenticator);
this._nonAuthenticatedFeatures=nonAuthenticatedFeatures;
this._$state=$state;
this._$modalStack=$modalStack;
this._userService=userService;
this._errorHandlers=errorHandlers;
}StateAuthenticator.prototype.

process=function process(event,toState){let toParams=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{};let fromState=arguments[3];let fromParams=arguments[4];
this._mostRecentlyProcessedState=toState;
this._mostRecentlyProcessedParams=toParams;

if(!this._requiresAuthentication(toState)||this._hasBeenAuthenticated(toParams)){
let top=this._$modalStack.getTop();

if(_.exists(top)){
if(this._requiresAuthentication(toState)&&this._hasBeenAuthenticated(toParams)||fromState.name!==this._loginFeatureName){

this._$modalStack.dismiss(top.key);
}else if(!this._hasBeenAuthenticated(toParams)&&toState.name===this._loginFeatureName){


this._$modalStack.dismiss(top.key);
}
}
return;
}

event.preventDefault();

this._tryToContinueToAuthenticatedState();
};StateAuthenticator.prototype.

_requiresAuthentication=function _requiresAuthentication(state){
return!_(this._nonAuthenticatedFeatures).includes(state.name);
};StateAuthenticator.prototype.

_hasBeenAuthenticated=function _hasBeenAuthenticated(params){
return _.exists(params.authenticated)&&params.authenticated===!0;
};StateAuthenticator.prototype.

_tryToContinueToAuthenticatedState=function(){var ref=_asyncToGenerator(function*(){
let error=void 0;
let errorHandler=void 0;
try{
yield this._userService.continueUserSession();
}catch(e){
errorHandler=this._errorHandlers.handlerFor(e);
if(!_.exists(errorHandler)){
throw e;
}
error=e;
}

if(!this._requiresAuthentication(this._mostRecentlyProcessedState)){
return;
}

if(_.exists(errorHandler)){
errorHandler(error);
return;
}

this._mostRecentlyProcessedParams.authenticated=!0;
this._$state.go(this._mostRecentlyProcessedState.name,this._mostRecentlyProcessedParams);
});function _tryToContinueToAuthenticatedState(){return ref.apply(this,arguments)}return _tryToContinueToAuthenticatedState}();_createClass(StateAuthenticator,[{key:'_loginFeatureName',get:function()

{
return this._nonAuthenticatedFeatures[0];
}}]);return StateAuthenticator}();


module.exports=StateChangeDirective;
//# sourceMappingURL=stateChangeDirective.js.map
